import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useViewport } from '@chilecompra/react-kit'
import { REGION_IMAGE_BASE_URL } from '../../config/settings/constants'
import routes from '../../config/settings/routes'
import { ContainerImg, GridContainer, Image, Overlay, TextImg } from './HomeRegions.styles'

/**
 * The HomeRegions's component.
 */
const RegionImage = props => {
  const { imageOne, imageTwo, imageThree, nameOne, nameTwo, nameThree } = props
  const { size } = useViewport()
  const navigate = useNavigate()

  const handleRouteTo = useCallback(
    image => () => navigate(routes.regionalInfo.replace(/:regionSlug/, image.split('.')[0])),
    []
  )

  return (
    <GridContainer justifyContent="center" key={1}>
      <ContainerImg
        height="295px"
        textAlign="left"
        width={size.isUpToMedium ? '282px' : '80%'}
        onClick={handleRouteTo(imageOne)}
      >
        <Image src={`${REGION_IMAGE_BASE_URL}${imageOne}`} />
        <Overlay />
        <TextImg fontSize="24px" left="42%" top="42%">
          {nameOne}
        </TextImg>
      </ContainerImg>
      {!!imageTwo && (
        <ContainerImg height="295px" textAlign="left" width="282px" onClick={handleRouteTo(imageTwo)}>
          <Image src={`${REGION_IMAGE_BASE_URL}${imageTwo}`} />
          <Overlay />
          <TextImg fontSize="24px" left="42%" top="42%">
            {nameTwo}
          </TextImg>
        </ContainerImg>
      )}
      {!!imageThree && (
        <ContainerImg height="295px" textAlign="left" width="282px" onClick={handleRouteTo(imageThree)}>
          <Image src={`${REGION_IMAGE_BASE_URL}${imageThree}`} />
          <Overlay />
          <TextImg fontSize="24px" left="42%" top="42%">
            {nameThree}
          </TextImg>
        </ContainerImg>
      )}
    </GridContainer>
  )
}

RegionImage.defaultProps = {
  imageOne: '',
  imageTwo: '',
  imageThree: '',
  nameOne: '',
  nameTwo: '',
  nameThree: ''
}

RegionImage.propTypes = {
  imageOne: PropTypes.string,
  imageTwo: PropTypes.string,
  imageThree: PropTypes.string,
  nameOne: PropTypes.string,
  nameTwo: PropTypes.string,
  nameThree: PropTypes.string
}

export default RegionImage
